<template>
  <div class="recently-viewed">
    <div class="recently-viewed__header">
      <div class="recently-viewed__title">
        Recently Viewed
      </div>
      <div
        v-if="history.list.length > 0"
        class="recently-viewed__clear"
        @click.stop="clearHistory"
      >
        Clear Viewed
      </div>
    </div>
    <div
      class="recently-viewed__list"
      v-if="history.list.length > 0"
    >
      <div
        v-for="item in history.list"
        :key="item.offerId"
        class="recently-viewed-item"
        @click="onItemClick(item)"
      >
        <Image
          class="recently-viewed-item__image"
          :src="item.imageUrl"
          alt=""
        />
        <div class="recently-viewed-item__content">
          <div class="recently-viewed-item__title">
            {{ item.subjectTrans }}
          </div>
          <div class="recently-viewed-item__price">
            <IntlCurrency :currency="currency.current.targetCurrency" />
            {{ productPrice(item) }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="recently-viewed-empty"
      v-else
    >
      <img
        class="recently-viewed-empty__image"
        src="@/assets/result/empty.svg"
      >
      <p class="recently-viewed-empty__content">
        We haven’t found any items here.
      </p>
    </div>
  </div>
</template>

<script setup>
import { useHistoryStore } from '@/pinia/history'
import { Image } from '../Image'
import { IntlCurrency } from '../NewIntlCurrency'
import { bankersRoundWithMax, buriedPointUtil, openURLWithChannelQuery } from '@/utils/utils'
import { useCurrencyStore } from '@/pinia/currency'

const history = useHistoryStore()

const currency = useCurrencyStore()

const productPrice = computed(() => (item) => {
  if (item) {
    const price = item?.priceInfo?.price || 0
    return bankersRoundWithMax(price * currency.current.rate, 0.01)
  } else {
    return ''
  }
})

const clearHistory = () => {
  history.clear()
  buriedPointUtil({ eventId: 'PRV202' })
}

const onItemClick = (item) => {
  buriedPointUtil({ eventId: 'PRV201', others: { offerId: item.offerId } })
  openURLWithChannelQuery(`/offer/${item.offerId}?key=${btoa(item.monthSold)}`)
}
</script>

<style lang="less" scoped>
.recently-viewed {
  width: 280px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
  }

  &__title {
    color: #232323;
    font-size: 14px;
    font-family: mon-700;
  }

  &__clear {
    color: #5c5c5c;
    font-size: 11px;
    font-family: mon-500;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      color: #004F9A;
    }
  }

  &__list {
    max-height: 360px;
    overflow-y: scroll;
    padding: 0 8px 16px;
  }

  &-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;

    &:hover {
      background-color: #f8f8f8;
      border-radius: 6px;
      cursor: pointer;
    }

    &__image {
      flex-shrink: 0;
      width: 56px;
      height: 56px;
      border-radius: 4px;
      border: 1px solid #ebf1f5;
    }

    &__content {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

    &__title {
      color: #232323;
      font-size: 12px;
      font-family: mon-500;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    &__price {
      display: flex;
      align-items: center;
      color: #232323;
      font-size: 12px;
      line-height: 16px;
      font-family: mon-600;
    }
  }

  &-empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    padding: 0 16px 16px;

    &__image {
      width: 120px;
      height: 120px;
    }

    &__content {
      font-family: mon-500;
      font-size: 11px;
      line-height: 14px;
      color: #6E717A;
    }
  }
}
</style>
